import Auth from "./auth";
import Forms from "./forms";


export {
    Forms
};

export default Auth;